import * as tslib_1 from "tslib";
import m from 'mithril';
import { Breakpoint } from './breakpoint';
import { View } from './view';
var MediaQuery = /** @class */ (function (_super) {
    tslib_1.__extends(MediaQuery, _super);
    function MediaQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaQuery.prototype.render = function () {
        var _a;
        var _b = this.attrs, view = _b.view, minWidth = _b.minWidth, maxWidth = _b.maxWidth;
        var rules = [];
        if (minWidth)
            rules.push("(min-width: " + minWidth + "px)");
        if (maxWidth)
            rules.push("(max-width: " + maxWidth + "px)");
        var query = rules.join(' and ');
        return m(Breakpoint, (_a = {}, _a[query] = true, _a), function (match) { return match && view(); });
    };
    return MediaQuery;
}(View));
export { MediaQuery };
